import styled from 'styled-components'

export default styled.ul`
  width: 100%;
  justify-content: flex-start
`
